import BugSnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'

export const addMetaData = metaData => {
	if (!window?.initialData?.bug_tracking) {
		return
	}
	_.forEach(metaData, (value, key) => {
		BugSnag.addMetadata(key, value)
	})
}
export const notifyError = (error, { metaData, message, onError } = {}) => {
	if (!window?.initialData?.bug_tracking) {
		return
	}
	if (error instanceof Error && error.message === 'Network Error') {
		return
	}
	_.forEach(metaData, (value, key) => {
		BugSnag.addMetadata(key, value)
	})

	const response = error instanceof Error ? error.response?.data : error

	if (response) {
		BugSnag.addMetadata('response', response)
	}

	BugSnag.notify(message || error, onError)

	_.forEach(metaData, (value, key) => {
		BugSnag.addMetadata(key, null)
	})
	if (response) {
		BugSnag.addMetadata('response', null)
	}
}

export const createErrorBoundary = () => {
	if (!window.initialData.bug_tracking) {
		return React.Fragment
	}

	BugSnag.start({
		apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
		plugins: [new BugsnagPluginReact()],
		releaseStage: import.meta.env.VITE_BUGSNAG_RELEASE_STAGE,
		enabledReleaseStages: ['production', 'staging'],
		onError: event => {
			const message = event.originalError?.message || ''
			return (
				// eslint-disable-next-line no-underscore-dangle
				!event._metadata?.['unhandledrejection handler'] &&
				!new RegExp('fbq', 'gi').test(message) &&
				!new RegExp('ResizeObserver loop limit exceeded', 'gi').test(message)
			)
		},
	})
	return BugSnag.getPlugin('react').createErrorBoundary(React)
}
